import { RoomSelectorBase } from './RoomSelector.base';
import {
    RoomSelectorProps,
    RoomSelectorStyleProps,
    RoomSelectorStyles,
} from './RoomSelector.types';
import { styled } from '@fluentui/react/lib/Utilities';

export { RoomSelectorProps };

/** The default style of RoomSelector */
export function getStyles(styleProps: RoomSelectorStyleProps): RoomSelectorStyles {
    return {};
}

/** The default styled version of RoomSelector */
export const RoomSelector = styled<RoomSelectorProps, RoomSelectorStyleProps, RoomSelectorStyles>(
    RoomSelectorBase,
    getStyles
);
export { CalendarEventTime } from './RoomSelector.types';
